import styled, { FlattenSimpleInterpolation, css } from 'styled-components'
import MessageBox from 'syf-component-library/ui/patterns/MessageBox'
import { H3 } from 'syf-component-library/ui/typography'

export const MessageBoxContainer = styled(MessageBox)`
  & button {
    width: 24px;
    height: 24px;
  }
  & button svg {
    font-size: 24px;
  }
`

export const Title = styled(H3)`
  font-size: 16px;
`

const getMargin = (): FlattenSimpleInterpolation => {
  return css`
    margin: 32px 62px;
  `
}

export const IEBannerWrapper = styled.div<{
  isInternalPage?: boolean
}>`
  margin: 0 0 42px 0;
  ${({ isInternalPage }) => isInternalPage && getMargin()};
`
